import { OpenPanel } from "@openpanel/web";
import { environment } from "src/environments/environment";
import {
  getCurrentSoftwareProduct,
  SoftwareProduct
} from "src/app/support/product";

let client: OpenPanel | null = null;

export function isOpenPanelEnabled(): boolean {
  const clientId: string = environment.snoots.openpanel.clientId;

  return (
    environment.snoots.production &&
    window.location.toString().indexOf("pms.local.pet") <= 0 &&
    getCurrentSoftwareProduct() === SoftwareProduct.PMS &&
    clientId.length > 0
  );
}

export function initOpenPanel(): void {
  if (!isOpenPanelEnabled() || client) {
    return;
  }

  client = new OpenPanel({
    clientId: environment.snoots.openpanel.clientId,
    apiUrl: environment.snoots.openpanel.apiUrl,
    clientSecret: environment.snoots.openpanel.clientSecret,
    trackScreenViews: true,
    trackOutgoingLinks: false,
    trackAttributes: true
  });

  client.setGlobalProperties({
    product: "pms",
    environment: "prod"
  });
}

export function getOpenPanelClient(): OpenPanel | null {
  return client;
}

export function identifyOpenPanelMember(
  member: {
    id: string;
    firstName: string;
    lastName: string;
    position?: string;
  },
  tenant: { id: string; name: string }
): void {
  if (!client) {
    return;
  }

  // Self-hosted OpenPanel (op.snoots.pet) currently rejects type "group" /
  // "assign_group". Attach tenant as profile + global properties instead of
  // upsertGroup/setGroup until the instance supports Groups.
  const profileProperties: Record<string, string> = {
    tenant_id: tenant.id,
    tenant_name: tenant.name
  };

  if (member.position) {
    profileProperties["position"] = member.position;
  }

  void client.identify({
    profileId: member.id,
    firstName: member.firstName,
    lastName: member.lastName,
    properties: profileProperties
  });

  client.setGlobalProperties({
    tenant_id: tenant.id,
    tenant_name: tenant.name
  });
}

export function trackOpenPanelProductEvent(
  area: string,
  entity: string,
  action: string,
  properties: Record<string, string | undefined>
): void {
  if (!client) {
    return;
  }

  const eventProperties: Record<string, string> = {};

  for (const [key, value] of Object.entries(properties)) {
    if (value !== undefined) {
      eventProperties[key] = value;
    }
  }

  void client.track(`${area}.${entity}.${action}`, eventProperties);
}

export function clearOpenPanelSession(): void {
  client?.clear();
}
